import { IPayout, TSortPayoutByHeaderTitle } from 'types';
import { PayoutListElement } from '../PayoutListElement';
import { PayoutListHeader } from '../PayoutListHeader';
import { StyledPayoutList } from './styles';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectPayouts } from 'store/slices/userPayoutSlice';
import { getNextSortDir } from 'utils';
interface IPayoutListProps {
  children?: React.ReactNode;
  onSort: (sortBy: { sortBy: keyof IPayout; sortDir: 'ASC' | 'DESC' | 'NONE' }) => void;
}

export const PayoutList = ({ onSort }: IPayoutListProps) => {
  const [sortBy, setSortBy] = useState<string | null>(null);
  const [sortDir, setSortDir] = useState<'ASC' | 'DESC' | 'NONE'>('NONE');
  const sortHandler = (nextSortBy: TSortPayoutByHeaderTitle) => {
    const nextSortDir = getNextSortDir(sortBy, nextSortBy, sortDir);
    onSort({ sortBy: nextSortBy, sortDir: nextSortDir });
    setSortBy(nextSortBy);
    setSortDir(nextSortDir);
  };

  const payouts = useSelector(selectPayouts);

  return (
    <StyledPayoutList>
      <PayoutListHeader onSort={sortHandler} sortBy={sortBy} sortDir={sortDir} />
      {payouts.map((payout) => (
        <PayoutListElement key={payout.id} {...payout} />
      ))}
    </StyledPayoutList>
  );
};
